module.exports = __webpack_public_path__ + "static/media/toiletpaper.ded45726.jpeg";